import { render, staticRenderFns } from "./GradeFilters.vue?vue&type=template&id=2a772894"
import script from "./GradeFilters.vue?vue&type=script&lang=js"
export * from "./GradeFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports